import {  ListService, } from '@abp/ng.core';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import {
  LocationTreeNode,
} from '@/locations/models/location-tree-node.model';
import { LocationDefinition, LocationService } from '@register/proxy/register-service/locations';

@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss'],
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
})
export class LocationPickerComponent implements OnInit, OnChanges {
  @Input() name: string;
  @Input() readonly: boolean = true;
  @Input() displayName: string;
  @Input() type: string;
  @Input() locationDefinition: LocationDefinition;
  @Input() hasAssociatedInspections: boolean;
  @Input() hasAssociatedAssets: boolean;
  @Input() withoutLocation: boolean = false;
  @Input() withLookup: boolean = false;
  @Output() nodeSelected = new EventEmitter<LocationTreeNode>();

  selectedLocation?: LocationTreeNode = null;
  selectedLocationTemp?: LocationTreeNode = null;
  isModalOpen = false;

  constructor(public readonly list: ListService, public readonly service: LocationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.name.currentValue === null) {
      this.selectedLocation = null;
      this.selectedLocationTemp = null;
    }
  }
  ngOnInit(): void {
    this.displayName = this.displayName?.charAt(0).toUpperCase() + this.displayName?.slice(1);
  }

  onSelectedNodeChange($event: LocationTreeNode) {
    this.selectedLocationTemp = $event;
  }

  onSelectClicked() {
    this.name = null;
    this.isModalOpen = true;
  }

  onSelect() {
    this.selectedLocation = this.selectedLocationTemp;
    this.selectedLocationTemp = null;
    this.name = this.selectedLocation.name;
    this.isModalOpen = false;
    this.nodeSelected.emit(this.selectedLocation);
  }

  onCancel() {
    this.name = null;
    this.selectedLocationTemp = null;
    this.isModalOpen = false;
  }

  onRemove() {
    const selectedLocationDefinition =
      this.selectedLocation?.locationDefinition || this.locationDefinition;
    this.selectedLocation = null;
    this.selectedLocationTemp = null;
    this.name = null;
    this.nodeSelected.emit({
      id: null,
      parentId: null,
      fullName: null,
      isActive: null,
      notes: null,
      path: null,
      pictureUrl: null,
      locationDefinition: selectedLocationDefinition,
    });
  }
}
